import type { LabsResourceID, LabsResourceType } from "@/client/core/platform-types/labs.api";
import { isObject } from "@/shared/utils/typeGuards";

export const isLabsResourceID = <T extends LabsResourceType>(
    value: unknown,
    type: T,
): value is LabsResourceID<T> => {
    if (!isObject<{ value: unknown; type: unknown }>(value)) {
        return false;
    }
    if (typeof value.value !== "string") {
        return false;
    }
    if (value.type !== type) {
        return false;
    }
    return true;
};
